import { memo } from 'react';
import type { FC } from 'react';
import { useTranslation,Trans } from 'react-i18next';

import resets from '../_resets.module.css';
import classes from './About_edu.module.scss';



/*Title*/
import { SectionTitle } from "../common/SectionTitle/SectionTitle";
import { SectionTitle_sub } from "../common/SectionTitle_sub/SectionTitle_sub";

/*section*/
import { PageTitle } from "../common/PageTitle/PageTitle";
import { Contact } from "../common/Contact/Contact";
import { PointCarousel } from "./PointCarousel/PointCarousel";
import { WhyDialogue } from "./WhyDialogue/WhyDialogue";
import { ExpertVoice } from "./ExpertVoice/ExpertVoice";
import { ValueSurvey } from "./ValueSurvey/ValueSurvey";
import { UsageExampleSection } from "../common/UsageExampleSection/UsageExampleSection";
import { GradientCta } from "../common/GradientCta/GradientCta";

/*images*/
import fieldCourt from "../../assets/images/field_court.webp";
import illustAttack from "../../assets/images/illust_attack.png";
import illustDefend from "../../assets/images/illust_defend.png";
import illustDodge from "../../assets/images/illust_dodge.png";
import illustTeamwork from "../../assets/images/illust_teamwork.png";
// TODO: 教育的価値の写真は仮。本番写真に差し替え予定
import valueImg01 from "../../assets/images/dSC008951.jpeg";
import valueImg02 from "../../assets/images/IMG_3594.png";
import valueImg03 from "../../assets/images/eduvalue03_achievement.webp";
import valueImg04 from "../../assets/images/iMG_133121.jpeg";
import valueImg05 from "../../assets/images/eduvalue05_dialogue.webp";



interface Props {
  className?: string;
}


export const About_edu: FC<Props> = memo(function About_edu(props = {}) {
  const { t } = useTranslation();

  const overviewItems = [
    { key: 'device', icon: 'fa-gamepad' },
    { key: 'action', icon: 'fa-bolt' },
    { key: 'team', icon: 'fa-users' },
    { key: 'review', icon: 'fa-stopwatch' },
  ] as const;
  const eduValueImgs = [valueImg01, valueImg02, valueImg03, valueImg04, valueImg05];
  const actionKeys = [
    { key: 'attack', img: illustAttack },
    { key: 'defense', img: illustDefend },
    { key: 'dodge', img: illustDodge },
    { key: 'teamwork', img: illustTeamwork },
  ] as const;

  return (

    <div className={`${resets.clapyResets} ${classes.aboutEdu} aboutEdu contents`}>

<PageTitle
          className={classes.pageTitle}
          title={t('about:pageTitle')}
          subTitle={t('about:pageSubTitle')}
        />

 {/*point------------*/}
<section className={classes.point}>
  <SectionTitle
            className={classes.pointTitle}
            classes={{color:"grad"}}
            text="POINT"
          />
          <SectionTitle_sub
            className={classes.pointSubTitle}
            text={t('about:pointSubTitle')}
          />
  <PointCarousel />
</section>

{/*whatIsHado------------*/}
<section className={`${classes.whatIsHado} LargeMarginUnder`}>
  <h2 className={classes.whatIsHadoTitle}>
    <span className={classes.titleLead}>HADO</span>は<br className="sponly" />
    <span className={classes.titleHighlight}>「身体を動かし、<br className="sponly" />作戦を考え、振り返る」</span>
    <br />次世代のスポーツです。
  </h2>

  <div className={classes.videoWrapper}>
    <iframe
      src="https://www.youtube.com/embed/AbOnXhbnh2s"
      title="HADO"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </div>

  {/*overview*/}
  <div className={`${classes.whatIsHadoBlock} contentWidth`}>
    <h3 className={classes.whatIsHadoSubTitle}><span>{t('about:whatIsHado.overviewTitle')}</span></h3>
    <div className={classes.fieldImage}>
      <img src={fieldCourt} alt="" />
    </div>
    <ul className={classes.overviewList}>
      {overviewItems.map(({ key, icon }) => (
        <li className={classes.overviewItem} key={key}>
          <span className={classes.overviewIcon}><i className={`fas ${icon}`} /></span>
          <div className={classes.overviewItemBody}>
            <div className={classes.overviewItemTitle}>{t(`about:whatIsHado.overview.${key}.title`)}</div>
            <div className={classes.overviewItemText}><Trans i18nKey={`about:whatIsHado.overview.${key}.description`} components={{ 1: <br className="sponly" />, 2: <span className="nowrap" /> }} /></div>
          </div>
        </li>
      ))}
    </ul>
  </div>

  {/*basic actions*/}
  <div className={`${classes.whatIsHadoBlock} contentWidth`}>
    <h3 className={classes.whatIsHadoSubTitle}><span>{t('about:whatIsHado.actionTitle')}</span></h3>
    <ul className={classes.actionList}>
      {actionKeys.map(({ key, img }) => (
        <li className={classes.actionItem} key={key}>
          <div className={classes.actionItemImgWrap}>
            <img src={img} className={classes.actionItemImg} alt="" />
          </div>
          <div className={classes.actionItemTitle}>{t(`about:whatIsHado.action.${key}`)}</div>
        </li>
      ))}
    </ul>
  </div>

  {/*rules*/}
  <div className={`${classes.whatIsHadoBlock} contentWidth`}>
    <h3 className={classes.whatIsHadoSubTitle}><span>{t('about:whatIsHado.ruleTitle')}</span></h3>
    <div className={classes.ruleText}><Trans i18nKey="about:whatIsHado.ruleText" components={{ 1: <br className="sponly" /> }} /></div>
    <div className={classes.videoWrapper}>
      <iframe
        src="https://www.youtube.com/embed/qE8g0NMBc34"
        title={t('about:whatIsHado.ruleVideoTitle')}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
    <div className={classes.ruleVideoCredit}>{t('about:whatIsHado.ruleVideoCredit')}</div>
  </div>
</section>

{/*educational value------------*/}
<section className={classes.eduValue}>
  <h2 className={classes.eduValueTitle}><Trans i18nKey="about:eduValue.title" components={{ 1: <span className={classes.eduValueHighlight} /> }} /></h2>
  <ul className={`${classes.valueList} contentWidth`}>
    {eduValueImgs.map((img, idx) => {
      const i = idx + 1;
      return (
        <li className={classes.valueItem} key={i}>
          <div className={classes.valuePhoto}>
            {i === 2 ? <ValueSurvey /> : <img src={img} alt="" />}
          </div>
          <div className={classes.valueBody}>
            <div className={classes.valueNum}>{`0${i}`}</div>
            <div className={classes.valueTextWrap}>
              <h3 className={classes.valueItemTitle}><Trans i18nKey={`about:eduValue.value0${i}.title`} components={{ 1: <br className="sponly" /> }} /></h3>
              <p className={classes.valueItemText}><Trans i18nKey={`about:eduValue.value0${i}.description`} components={{ 1: <br className="sponly" />, 2: <span className="nowrap" /> }} /></p>
            </div>
          </div>
        </li>
      );
    })}
  </ul>
  <div className={classes.eduValueConclusion}><span className={classes.underLine}><Trans i18nKey="about:eduValue.conclusion" components={{ 1: <br className="sponly" /> }} /></span></div>
</section>

{/*why dialogue------------*/}
<WhyDialogue />

{/*Usage example------------*/}
<UsageExampleSection />

{/*expert voice------------*/}
<ExpertVoice />

{/*cases CTA------------*/}
<GradientCta to="interview" text={t('about:casesCta')} />

{/*contact------------*/}
<Contact className={classes.contact} />
    </div>
  );
});
